// const cellStyles = {
//   billingDate: {backgroundColor: '#ab85ad', color: '#fff'},
//   amountReceivableWithoutTax: {backgroundColor: '#eebcbc', color: '#545454'},
//   amountReceivableWithTax: {backgroundColor: '#ef9a9a', color: '#fff'}
// }

import { programmaticProviderStatusMapping, simplePaymentStatusMapping } from "../../misc"    
import { currencyFormatter, stringFormatter, PERMISSIONS } from "../../strings"
import { dateFormatter } from "../formatters"
import paymentGetters, { filesDataGetter } from "./getters"
import { checkPermissions } from "../../security"


export const columnDefs = ({openPoModal, handleFilter, getValues})=> ([
    {
      headerName: 'Campaña',
      headerClass: 'column-group-1',
      children: [
        {
          headerName: 'ID',
          valueGetter: paymentGetters.campaign.getId,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          pinned: 'left',
          lockPinned: true,
          width: 150
        },
        {
          headerName: 'Nombre campaña',
          valueGetter: paymentGetters.campaign.getName,
          filter: false,
          width: 300,
          wrapText: true
        },
        {
          headerName: 'Multimes',
          valueGetter: paymentGetters.campaign.getMultiMonth,
          filter: true,
          floatingFilterComponentParams: {
            handleFilter,
            suppressFilterButton: true,
            getValues,
            columnName: 'is_campaign_longer_than_one_month'
          },
          floatingFilterComponent: "booleanFilter",
          width: 200,
          wrapText: true
        },
        {
          headerName: 'Fecha de Inicio',
          valueGetter: paymentGetters.campaign.getFromDate,
          valueFormatter: dateFormatter,
          filter: false,
          width: 180
        },
        {
          headerName: 'Fecha de Fin',
          valueGetter: paymentGetters.campaign.getToDate,
          valueFormatter: dateFormatter,
          filter: false,
          width: 150
        },
        {
          headerName: 'Tipo de campaña',
          valueGetter: paymentGetters.campaign.getCampaignType,
          filter: false,
          width: 150
        },
        {
          headerName: 'Comentario',
          valueGetter: paymentGetters.campaign.getComment,
          cellRenderer: 'commentRenderer',
          hide: !checkPermissions([PERMISSIONS.EDIT_CAMPAIGN_COMMENTS]),
          filter: false,
          cellRendererParams: {
            campaignId: paymentGetters.campaign.getId,
          },
          width: 250,
          wrapText: true,
        },
      ]
    },
    {
      headerName: 'Pantalla',
      headerClass: 'column-group-4',
      children: [
        {
          headerName: 'ID Empresa',
          valueGetter: paymentGetters.company.getId,
          filter: false,
          width: 150
        },
        {
          headerName: 'Empresa Pantallero',
          filter: false,
          valueGetter: paymentGetters.company.getName,
          width: 200
        },
        {
          headerName: 'Holding',
          valueGetter: paymentGetters.company.getHolding,
          filter: false,
          width: 200
        },
        {
          headerName: 'Proveedor Programático',
          valueGetter: paymentGetters.company.getProgrammaticProvider,
          refData: programmaticProviderStatusMapping(),
          filter: true,
          width: 200,
          floatingFilterComponentParams: {
            handleFilter,
            suppressFilterButton: true,
            getValues,
          },
          floatingFilterComponent: "programmaticProviderFilter",
        },
        {
          headerName: 'País',
          valueGetter: paymentGetters.company.getCountry,
          filter: true,
          width: 200,
          floatingFilterComponentParams: {
            handleFilter,
            suppressFilterButton: true,
            getValues,
          },
          floatingFilterComponent: "countryFilter",
        }
      ]
    },
    {
      headerName: 'Operación',
      headerClass: 'column-group-2',
      children: [
        {
          headerName: 'Divisa',
          valueGetter: paymentGetters.operation.getCurrencyToPay,
          width: 200,
          filter: false
        },
        {
            headerName: 'Total a pagar',
            valueGetter: paymentGetters.operation.getAmountConsumed,
            valueFormatter: currencyFormatter,
            filter: false,
            width: 350,
            colId: 'amount_consumed',
        },
        {
            headerName: 'Total presupuestado',
            valueGetter: paymentGetters.operation.getAmountBudgeted,
            valueFormatter: currencyFormatter,
            filter: false,
            width: 350
        },
        //Agregar "Estado de facturación"
        {
          headerName: 'Facturado',
          valueGetter: filesDataGetter,
          cellRenderer: 'billingAmountRenderer',
          cellRendererParams: {
            labelChip: 'Facturado',
            field: 'invoiced_at'
          },
          filter: false,
          width: 120,
          cellStyle: {paddingLeft: '5px', paddingRight: '5px'},
          pinned: 'left',
          refData: simplePaymentStatusMapping()
        },
        {
          headerName: 'Pagado',
          valueGetter: filesDataGetter,
          cellRenderer: 'billingAmountRenderer',
          cellRendererParams: {
            labelChip: 'Pagado',
            field: 'paid_at'
          },
          filter: true,
          floatingFilterComponentParams: {
            handleFilter,
            suppressFilterButton: true,
            getValues,
            columnName: 'is_paid',
            defaultValue: 0
          },
          floatingFilterComponent: "booleanFilter",
          width: 120,
          cellStyle: {paddingLeft: '5px', paddingRight: '5px'},
          pinned: 'left',
          refData: simplePaymentStatusMapping()
        },

        {
            headerName: 'Tax',
            valueGetter: paymentGetters.operation.getTax,
            width: 150
        },
        {
            headerName: 'Tipo de venta',
            valueGetter: paymentGetters.operation.getExternalDsp,
            filter: false,
            width: 200,
            wrapText: true
        },
        {
          headerName: 'Fecha de pago',
          valueGetter: paymentGetters.operation.getPaymentDate,
          valueFormatter: dateFormatter,
          filter: false,
          width: 150
        },
        {
          headerName: 'Días de atraso de pago',
          valueGetter: paymentGetters.operation.getPaymentDelay,
          filter: false,
          width: 150
        },
        {
            headerName: 'Documentación',
            // field: 'company.purchase_order',
            pinned: 'left',
            cellStyle: {textAlign: 'center'},            
            filter: false,
            cellRenderer: (params) => {
                const {data} = params
                const {company, campaign} = data
                const {purchase_orders, id: companyId} = company
                const {id: campaignId} = campaign
                
                const button = document.createElement('a')
                button.innerText = 'Ver'
                button.style.cursor = 'pointer'
                button.addEventListener('click', (event) => {
                  event.stopPropagation()
                  const fileData = purchase_orders ? purchase_orders.map((fileData) => fileData) : []
                  
                  openPoModal({campaignId, companyId}, fileData)
                })
                return button
            }

        }
      ]
    },
    {
      headerName: 'Datos de facturación',
      headerClass: 'column-group-3',
      children: [
        {
          headerName: 'Cotización del día',
          valueGetter: paymentGetters.operation.getRate,
          valueFormatter: currencyFormatter,
          width: 150,
          filter: false,
        },
        {
          headerName: 'Impresiones prometidas',
          valueGetter: paymentGetters.operation.getPromisedShows,
          filter: false,
          width: 300
        },
        {
          headerName: 'Impresiones cumplidas',
          valueGetter: paymentGetters.operation.getImpressionsShowed,
          filter: false,
          width: 300
        },
        {
          headerName: 'Moneda (origen)',
          valueGetter: paymentGetters.operation.getRateFromCurrency,
          valueFormatter: stringFormatter,
          filter: false,
          floatingFilterComponent: "currencyFilter",
          width: 200
        },
        {
          headerName: 'Tasa de cambio (origen)',
          valueGetter: paymentGetters.operation.getRatesFromRate,
          // valueFormatter: currencyFormatter,
          filter: false,
          width: 270
        },
        {
          headerName: 'Moneda (destino)',
          valueGetter: paymentGetters.operation.getRateToCurrency,
          valueFormatter: stringFormatter,
          filter: false,
          width: 200
        },
        {
          headerName: 'Tasa de cambio (destino)',
          valueGetter: paymentGetters.operation.getRatesToRate,
          // valueFormatter: currencyCheck,
          filter: false,
          width: 270
        }
      ]
    }
  ])